export default [
  {
    label: "Dashboard financeiro",
    to: "/financial/financial-dashboard",
    icon: "fas fa-chart-line",
    controller: "Profit",
    action: "Get"
  },
  {
    separator: true
  },
  {
    label: "Faturamento",
    icon: "fas fa-file-invoice-dollar",
    items: [
      {
        label: "Faturamento dos clientes",
        to: "/financial/profits",
        icon: "fas fa-donate",
        controller: "Profit",
        action: "ListMerchant"
      },
      {
        label: "Notas de serviço dos clientes",
        to: "/financial/note-extracts",
        icon: "fas fa-file-invoice-dollar",
        controller: "NoteExtract",
        action: "List"
      },
      {
        label: "Isenções de mensalidade",
        to: "/financial/mensalidade-isencoes",
        icon: "fas fa-calendar-times",
        controller: "MensalidadeIsencao",
        action: "List"
      },
      {
        label: "Lançamentos manuais",
        to: "/financial/lancamentos-manuais",
        icon: "fas fa-pen-square",
        controller: "LancamentoManual",
        action: "List"
      },
      {
        separator: true
      },
      {
        label: "Comissões dos parceiros",
        to: "/financial/partner-commissions",
        icon: "fas fa-hand-holding-usd",
        controller: "CheckingAccountPartner",
        action: "List"
      },
      {
        label: "Notas de serviço dos parceiros",
        to: "/financial/note-extract-partners",
        icon: "fas fa-file-invoice-dollar",
        controller: "NoteExtractPartner",
        action: "List"
      }
    ]
  },
  {
    separator: true
  },
  {
    label: "Fornecedores",
    to: "/financial/provider",
    icon: "fas fa-handshake",
    controller: "Profit",
    action: "Get"
  },
  {
    separator: true
  },
  {
    label: "PIX Não Identificados",
    to: "/financial/pix-nao-identificados",
    icon: "fa-brands fa-pix",
    controller: "PixDiretoEmConta",
    action: "List"
  },
  {
    separator: true
  },
  {
    label: "Tesouraria",
    icon: "fas fa-piggy-bank",
    items: [
      {
        label: "Contas Bancárias",
        to: "/financial/bank-accounts",
        icon: "fas fa-clipboard-list",
        controller: "BankAccount",
        action: "List"
      },
      {
        label: "Conciliação Bancária",
        to: "/financial/bank-conciliation",
        icon: "fas fa-exchange-alt",
        controller: "BankConciliation",
        action: "List"
      },
      {
        separator: true
      },
      {
        label: "Contas a Receber",
        to: "/financial/accounts/receivable",
        icon: "fas fa-calendar-day",
        controller: "AccountsReceivable",
        action: "List"
      },
      {
        label: "Contas a Pagar",
        to: "/financial/accounts/payable",
        icon: "fas fa-calendar-day",
        controller: "AccountsPayable",
        action: "List"
      },
      {
        separator: true
      },
      {
        label: "Fluxo de Caixa",
        to: "/financial/cash-flow",
        icon: "fas fa-wave-square",
        controller: "CashFlow",
        action: "List"
      },
      {
        separator: true
      },
      {
        label: "Borderôs",
        to: "/financial/advance-payment-operations",
        icon: "fas fa-money-check",
        controller: "AdvancePaymentOperation",
        action: "List"
      },
      {
        separator: true
      },
      {
        label: "Transferências",
        to: "/financial/transfer-bank-accounts",
        icon: "fas fa-exchange-alt",
        controller: "TransferBankAccounts",
        action: "List"
      }
    ]
  },
  {
    separator: true
  },
  {
    label: "Categorias",
    icon: "fas fa-tags",
    items: [
      {
        label: "Contas a Pagar",
        to: "/financial/accounts-payable-category",
        icon: "fas fa-file-invoice-dollar",
        controller: "AccountsPayableCategory",
        action: "List"
      },
      {
        label: "Contas a Receber",
        to: "/financial/accounts-receivable-category",
        icon: "fas fa-hand-holding-usd",
        controller: "AccountsReceivableCategory",
        action: "List"
      },
      {
        separator: true
      },
      {
        label: "Conciliação C/P",
        to: "/financial/accounts-payable-conciliation",
        icon: "fas fa-exchange-alt",
        controller: "AccountsPayableConciliation",
        action: "List"
      },
      {
        label: "Conciliação C/R",
        to: "/financial/accounts-receivable-conciliation",
        icon: "fas fa-exchange-alt",
        controller: "AccountsReceivableConciliation",
        action: "List"
      }
    ]
  },
  {
    separator: true
  },
  {
    label: "Exportação de Dados",
    to: "/financial/advance-payment-operations",
    icon: "fas fa-database",
    controller: "AdvancePaymentOperation",
    action: "List"
  }
];


// WEBPACK FOOTER //
// ./src/data/menu-item-internal/financial-menu.js